<template>
    <div id="signature">
        <a-spin :spinning="loading">
            <div style="display: flex">
                <quill-editor
                    id="editor"
                    style="max-height: 14%; width: 58vw"
                    ref="signatureEditor"
                    @change="onEditorChange($event)"
                    :options="editorOption"
                    v-model="editorContent"
                />
                <div class="emoji-icon-wrapper" id="emoji-input" @click="emojiClickHandler">
                    <md-icon class="input-emoji-icon" style="cursor: pointer"> sentiment_very_satisfied</md-icon>
                </div>
                <div id="signature-emoji" v-if="showEmojiTable" class="emoji-table-container">
                    <EmojiPicker :onBlur="test" :onEmojiPicked="_handleEmojiPicked" />
                </div>
            </div>

            <div style="margin-top: 70px">
                <button class="save" @click="saveSignature">Kaydet</button>
            </div>
        </a-spin>
    </div>
</template>
<script>
import Vue from "vue";
import { mapState, mapGetters, mapActions } from "vuex";
import { log2 } from "../../../../utils/log2";
import EmojiPicker from "../../../../components/popup-chat/EmojiPicker.vue";

const log = log2("Signature.vue");
export default Vue.extend({
    name: "Signature",
    components: { EmojiPicker },
    data() {
        return {
            loading: false,
            showEmojiTable: false,
            editorContent: "",
            mailAddress: "",
            selectedId: this.$route.params.id,
            editorOption: {
                theme: "snow",
                modules: {
                    toolbar: [
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        ["bold", "italic", "underline", "strike"],
                        ["blockquote", "code-block"],
                        [{ header: 1 }, { header: 2 }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        [{ script: "sub" }, { script: "super" }],
                        [{ indent: "-1" }, { indent: "+1" }],
                        [{ direction: "rtl" }],
                        [{ color: [] }, { background: [] }],
                        [
                            {
                                font: [
                                    "Arial",
                                    "serif",
                                    "sans-serif",
                                    "宋体",
                                    "黑体",
                                    "Microsoft YaHei",
                                    "monospace",
                                    "cursive",
                                ],
                            },
                        ],
                        [{ font: ["mirza", "roboto"] }],
                        ["link"],
                    ],
                },
            },
        };
    },
    computed: {
        ...mapState({
            allMailAddresses: (state) => state.mail.allMailAddresses,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({
            saveSignatureAction: "mail/saveSignature",
            getMailSignature: "mail/getMailSignature",
        }),
        _handleEmojiPicked(emoji) {
            this.editorContent = this.editorContent + emoji;
        },
        onEditorChange({ quill, html, text }) {
            this.contentHtml = html;
        },
        emojiClickHandler() {
            this.showEmojiTable = true;
        },
        test() {
            this.showEmojiTable = true;
        },
        async saveSignature() {
            console.log("saveSignature", this.contentHtml);
            const result = await this.saveSignatureAction({
                mailAddress: this.mailAddress.mail,
                html: this.contentHtml,
            });
            console.log("result", result);

            if (result === true) {
                this.$message.success("İmza başarıyla kaydedildi");
            }
            // const test = editor.getContents();

            /*
            const insertEmbed = editor.insertEmbed(
                10,
                "image",
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSCvZHDV4ALx8J99rM2uwM1RPqZITgoFi3NnWqMgdr4edTwLgUlmcy0rPv_O-6Ml0EYgGo&usqp=CAU"
            );
            console.log("insertEmbed", insertEmbed);

            editor.insertText(5, "Quill", {
                color: "#ffff00",
                italic: true,
            });

            const deleteText = editor.deleteText(6, 4);
            const getLength = editor.getLength();
            const getText = editor.getText(0, 10);*/
        },
    },
    async mounted() {
        console.log("allMailAddresses", this.allMailAddresses);

        this.mailAddress = this.allMailAddresses.find(
            (email) => email._id === this.selectedId || (email.department && email.department._id === this.selectedId)
        );
        if (this.editorContent === "") {
            const signature = await this.getMailSignature({ mailAddress: this.mailAddress.mail });
            if (!!signature) {
                this.editorContent = signature.html;
            }
        }

        window.addEventListener("keydown", (e) => {
            if ("Escape" === e.key || "Esc" === e.key) {
                this.showEmojiTable = false;
            }
        });

        document.addEventListener("click", (e) => {
            const signatureEmoji = document.getElementById("signature-emoji");
            if (!!signatureEmoji && !signatureEmoji.contains(e.target)) {
                this.showEmojiTable = false;
            }
        });
    },
    watch: {
        async allMailAddresses(value) {
            console.log("allMailAddresses", value);
            this.mailAddress = value.find(
                (email) => email._id === this.selectedId || email.department === this.selectedId
            );
            if (this.value === "") {
                const signature = await this.getMailSignature({ mailAddress: this.mailAddress.mail });
                this.value = signature.html;
            }
        },
    },
});
</script>

<style scoped lang="scss">
.ql-toolbar.ql-snow + .ql-container.ql-snow {
    height: 50vh;
}

#signature {
    padding: 20px;
    background-color: #ffffff;
    height: 100%;
    width: 70vw;

    .emoji-icon-wrapper {
        margin-left: -38px;
        margin-top: 9px;
    }

    .save {
        padding: 15px;
        border-radius: 10px;
        background-color: #f6c26f;
        font-size: 15px;
        font-weight: 600;
        border: none;
    }
}
</style>
